import _ from 'lodash'

export function stripCsvSpaces (val) {
  if (!val || !val.split) return val
  const withoutSpaces = _.map(val.split(','), v => v.trim())// Eliminate nested spaces
  return _.reject(withoutSpaces, _.isEmpty).toString()
}

export function trimString (val = '') {
  return val.trim()
}

// Split a string by the passed character/pattern, ignoring any matches that
// fall within passed "quote" character pairs
export function splitOutsideQuotes (str, match = ' ', q, baseOffset = 0) {
  const rex = new RegExp(`${match}(?=(?:[^"]*"[^"]*")*[^"]*$)`, 'g')
  let m = null
  const output = []
  let lastEndIdx = baseOffset

  while ((m = rex.exec(str)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === rex.lastIndex) {
      rex.lastIndex++
    }
    m.forEach((/* matchInner, groupIndex */) => {
      // console.log(`Found match, group ${groupIndex}: ${match}`, m.index, rex.lastIndex)
      output.push({
        offset: lastEndIdx,
        length: m.index - lastEndIdx,
        match: str.substring(lastEndIdx, m.index)
      })

      lastEndIdx = rex.lastIndex
    })
  }

  if (output.length > 0) {
    // Add in any trailing characters
    const lastMatch = output[output.length - 1]
    const tailOffset = lastMatch.offset + lastMatch.length + match.length
    output.push({
      offset: tailOffset,
      length: str.length - tailOffset,
      match: str.substr(tailOffset)
    })
  } else {
    // No matches, just return the input as a lone match
    output.push({
      offset: baseOffset,
      length: str.length,
      match: str
    })
  }

  return output
}
